module.exports = __webpack_public_path__ + "img/link.dea3e695.png";